/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{NoParameters as t}from"../../core/shaderModules/interfaces.js";import{defaultOccludedFactor as e}from"../../../../support/HighlightDefaults.js";class i extends t{constructor(){super(...arguments),this.occludedFactor=e,this.maxHighlightLevel=1,this.verticalCellCount=0,this.horizontalCellCount=0,this.highlightLevel=0,this.pixelRatio=1}}export{i as HighlightPassParameters};
